import errorLogger, {
  BUGSNAG_STATUSES,
} from '@picsart/growth-rc/services/errorLogger';

import { getContext } from '@/context';
import getRemoteSettings from '@/utils/user/getRemoteSettings';
import isVideoContentFile from './isVideoContentFile';
import { MediaType } from '@/types';

import type { ContentFile } from '@/types';

type DownloadFileParams = {
  file: ContentFile;
};

const download = ({ src, name }: { src: string; name: string }) => {
  const link = document.createElement('a');
  link.href = src;
  link.download = name;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.contains(link) && document.body.removeChild(link);
};

const downloadFile = async ({ file }: DownloadFileParams) => {
  const isSdkDownloadAvailable = await getRemoteSettings({
    name: 'is_sdk_video_download_available',
    defaultValue: false,
    validate: (s) => typeof s === 'boolean',
  });

  const isVideoFile = isVideoContentFile(file);
  const isAudioFile = file.type === MediaType.AUDIO;
  const mimeType = isVideoFile
    ? 'video/mp4'
    : isAudioFile
    ? 'audio/mpeg'
    : 'image/png';

  try {
    getContext().handlers.isIOS() && isVideoFile && !isSdkDownloadAvailable
      ? download({ src: file.url, name: file.name })
      : await getContext().handlers.download([
          {
            name: file.name,
            mimeType,
            url: file.url,
          },
        ]);
  } catch (error) {
    errorLogger.trigger(error as Error, BUGSNAG_STATUSES.ERROR);
  }
};

export default downloadFile;
